"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var User_1 = require("../../graphql/User");
var client_1 = require("@apollo/client");
var context_1 = require("@apollo/client/link/context");
var cache_1 = __importDefault(require("../../cache"));
var User_2 = require("../../graphql/User");
var AccessControl_1 = require("./AccessControl");
var authLink = (0, context_1.setContext)(function (_, _a) {
    var headers = _a.headers;
    return __awaiter(void 0, void 0, void 0, function () {
        var return_headers, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    return_headers = { headers: __assign({}, headers) };
                    console.log(return_headers);
                    return_headers.headers.user_id = (0, AccessControl_1.getCurrentUserId)();
                    _b = return_headers.headers;
                    return [4 /*yield*/, (0, AccessControl_1.getAuthToken)()];
                case 1:
                    _b.auth_token = _c.sent();
                    console.log(return_headers);
                    return [2 /*return*/, return_headers];
            }
        });
    });
});
var httpLink = (0, client_1.createHttpLink)({
    uri: process.env.REACT_APP_NEXUS_SERVER_URL + '/graphql'
});
var client = new client_1.ApolloClient({
    cache: cache_1["default"],
    link: authLink.concat(httpLink)
});
var UserService = /** @class */ (function () {
    function UserService(client) {
        var _this = this;
        /**
         * Checks if email address is already in use
         * @param {string} email
         * @param {int|null} user_id
         * @return {Promise<boolean>} TRUE if email address exists, else FALSE
         */
        this.isEmailAddressInUse = function (email, user_id) {
            if (user_id === void 0) { user_id = null; }
            return _this.client
                .query({
                query: User_2.GetUserIdByEmail,
                variables: { email: email, user_id: user_id }
            })
                .then(function (_b) {
                var data = _b.data;
                return !!data.getUserIdByEmailAddress;
            });
        };
        /**
         * Checks if ORCID is already in use
         * @param {string} orcid
         * @param {number} user_id
         * @return {Promise<boolean>} True if orcid exists, else false
         */
        this.isORCIDInUse = function (orcid, user_id) {
            if (user_id === void 0) { user_id = null; }
            return _this.client
                .query({
                query: User_2.GetUserIdByORCID,
                variables: { orcid: orcid, user_id: user_id }
            })
                .then(function (_b) {
                var data = _b.data;
                return !!data.getUserIdByORCID;
            });
        };
        this.isHanfordIdInUse = function (hanford_id, user_id) {
            if (user_id === void 0) { user_id = null; }
            return _this.client
                .query({
                query: User_2.GetUserIdByHanfordId,
                variables: { hanford_id: hanford_id, user_id: user_id }
            })
                .then(function (_b) {
                var data = _b.data;
                return !!data.getUserIdByHanfordId;
            });
        };
        /**
         * Checks if the user has entered the unlisted ethnicity
         */
        this.isUnlistedEthnicityFilled = function (user_state, user_id) {
            if (user_id === void 0) { user_id = null; }
            return _this.client
                .query({
                query: User_1.GetEthnicityOptions
            })
                .then(function (_b) {
                var data = _b.data;
                var not_listed_uuid = data.getActiveEthnicityOptions.find(function (ethnicity) { return ethnicity.display_name === 'Not Listed'; }).attribute_value_uuid;
                return ((user_state.ethnicities || []).includes(not_listed_uuid) &&
                    (!Boolean(user_state.ethnicity_other) || !Boolean(user_state.ethnicity_other.trim())));
            });
        };
        this.isUnlistedGenderFilled = function (user_state, user_id) {
            if (user_id === void 0) { user_id = null; }
            return _this.client
                .query({
                query: User_2.GetUserInfoSelectionsPersonal
            })
                .then(function (_b) {
                var data = _b.data;
                var not_listed_uuid = data.getGenderIdentities.find(function (ethnicity) { return ethnicity.display_name === 'Prefer to self-describe'; }).attribute_value_uuid;
                return (user_state.gender_identity === not_listed_uuid &&
                    (!Boolean(user_state.gender_identity_other) || !Boolean(user_state.gender_identity_other.trim())));
            });
        };
        /**
         * Wrapper for static createNexusUserFromPnnlEmployee, using the local client (likely user session)
         * @param {string} employee_id - The ID of the PNNL Employee
         * @param {any[]} refetchQueries - The queries to refetch on completion
         * @return {Promise<number|undefined>} The user_id, if successfully, else undefined
         */
        this.createNexusUserFromPnnlEmployee = function (employee_id, refetchQueries) {
            if (refetchQueries === void 0) { refetchQueries = []; }
            return UserService.createNexusUserFromPnnlEmployee(employee_id, refetchQueries, _this.client);
        };
        this.client = client; // The ApolloClient for mutation
    }
    var _a;
    _a = UserService;
    /**
     * Gets BasicUserInfo from the provided id
     * @param {int} id - the user_id
     * @return {Promise<BasicUserInfo>} The user info
     */
    UserService.getBasicUserInfo = function (id) {
        return client
            .query({
            query: User_1.GetUserInformationFromKeycloak,
            fetchPolicy: 'no-cache',
            variables: { id: id }
        })
            .then(function (_b) {
            var keycloakData = _b.data;
            return {
                person_id: keycloakData.getUserInformationById.user_id,
                first_name: keycloakData.getUserInformationById.first_name,
                last_name: keycloakData.getUserInformationById.last_name,
                preferred_first_name: keycloakData.getUserInformationById.preferred_first_name,
                preferred_last_name: keycloakData.getUserInformationById.preferred_last_name,
                user_id: keycloakData.getUserInformationById.user_id,
                hanford_id: keycloakData.getUserInformationById.hanford_id,
                access: keycloakData.getUserInformationById.access.map(function (item) { return item.name; }),
                access_info: keycloakData.getUserInformationById.access
            };
        });
    };
    UserService.verifyUserDataForField = function (users, timeStamp, field) {
        var invalidUsers = [];
        return client
            .query({
            query: User_2.GetUncachedUserInformation,
            variables: { user_ids: users.map(function (user) { return user.person_id; }), timeStamp: timeStamp }
        })
            .then(function (_b) {
            var data = _b.data;
            var userData = data.getUserInformations;
            for (var _i = 0, userData_1 = userData; _i < userData_1.length; _i++) {
                var user = userData_1[_i];
                var information = JSON.parse(JSON.stringify(user));
                var fieldItem = information;
                var fieldArray = field.split('.');
                while (fieldArray.length > 1) {
                    fieldItem = fieldItem[fieldArray[0]];
                    fieldArray.shift();
                }
                if (!fieldItem[fieldArray[0]]) {
                    invalidUsers.push(UserService.getFormattedName_FirstLast(user));
                }
            }
            return invalidUsers;
        });
    };
    /**
     * Creates a new NEXUS user from a PNNL Employee
     * @param {string} employee_id - The ID of the PNNL Employee
     * @param {any[]} refetchQueries - The queries to refetch on completion
     * @param {ApolloClient} client - The client to mutate with
     * @return {Promise<number|undefined>} The user_id, if successfully, else undefined
     */
    UserService.createNexusUserFromPnnlEmployee = function (employee_id, refetchQueries, client // Default to System Client, for new user creation
    ) {
        if (refetchQueries === void 0) { refetchQueries = []; }
        return client
            .mutate({
            mutation: User_2.PnnlEmployeeToNexusUser,
            variables: { employee_id: employee_id },
            refetchQueries: refetchQueries
        })
            .then(function (_b) {
            var data = _b.data;
            if (data) {
                var newUser = data.pnnlEmployeeToNexusUser;
                return newUser.user_id;
            }
            else {
                return undefined;
            }
        });
    };
    /**
     * Returns `<last name>, <first name>` from BasicUserInfo
     * @param {BasicUserInfo} userInfo - the BasicUserInfo
     * @return {string} The formatted name
     */
    UserService.getFormattedName_LastCommaFirst = function (userInfo) {
        return UserService.getFormattedName(userInfo, function (user) {
            var first = user.preferred_first_name || user.first_name;
            var last = user.preferred_last_name || user.last_name;
            var firstFormat = first ? ", ".concat(first) : '';
            return "".concat(last).concat(firstFormat);
        });
    };
    /**
     * Returns `<first name> <last name>` from BasicUserInfo
     * @param {BasicUserInfo} userInfo - the BasicUserInfo
     * @return {string} The formatted name
     */
    UserService.getFormattedName_FirstLast = function (userInfo) {
        return UserService.getFormattedName(userInfo, function (user) {
            return "".concat(user.preferred_first_name || user.first_name || '', " ").concat(user.preferred_last_name || user.last_name);
        });
    };
    UserService.getFormattedLegalName_FirstLast = function (userInfo) {
        return UserService.getFormattedName(userInfo, function (user) { return "".concat(user.first_name || '', " ").concat(user.last_name || ''); });
    };
    UserService.getFormattedLegalName_FirstMiddleLast = function (userInfo) {
        return UserService.getFormattedName(userInfo, function (user) {
            return [user.first_name, user.middle_name, user.last_name].filter(function (name) { return !!name; }).join(' ');
        });
    };
    UserService.getFormattedLegalName_Full = function (userInfo) {
        return UserService.getFormattedName(userInfo, function (user) {
            return [user.first_name, user.middle_name, user.last_name].filter(function (name) { return !!name; }).join(' ');
        });
    };
    /**
     * Returns `<first name> <middle name> <last name>` from BasicUserInfo
     * @param {BasicUserInfo} userInfo - the BasicUserInfo
     * @return {string} The formatted name
     */
    UserService.getFormattedName_FirstMiddleLast = function (userInfo) {
        return UserService.getFormattedName(userInfo, function (user) {
            return "".concat(user.preferred_first_name || user.first_name || '', " ").concat(user.middle_name || '', " ").concat(user.preferred_last_name || user.last_name);
        });
    };
    /**
     * Returns `<last name>, <first name> (<preferred name>)` from BasicUserInfo
     * @param {BasicUserInfo} userInfo - the BasicUserInfo
     * @return {string} The formatted name
     */
    UserService.getFormattedName_ParenPreferred = function (userInfo) {
        return UserService.getFormattedName(userInfo, function (user) {
            var preferred_first = user.preferred_first_name && user.preferred_first_name !== user.first_name
                ? user.preferred_first_name
                : '';
            var preferred_last = user.preferred_last_name && user.preferred_last_name !== user.last_name ? user.preferred_last_name : '';
            if (preferred_first || preferred_last) {
                return "(".concat([preferred_first, preferred_last].filter(function (name) { return !!name; }).join(' '), ")");
            }
            return '';
        });
    };
    /**
     * Returns `<last name>, <first name> (<preferred name>)` from BasicUserInfo
     * @param {BasicUserInfo} userInfo - the BasicUserInfo
     * @return {string} The formatted name
     */
    UserService.getFormattedName_LastCommaFirstParenPreferred = function (userInfo) {
        return UserService.getFormattedName(userInfo, function (user) {
            var first = user.first_name || user.preferred_first_name; // If no first name, use preferred
            var firstFormat = first ? ", ".concat(first) : ''; // If no first, nothing, else include comma
            var preferredFormat = UserService.getFormattedName_ParenPreferred(userInfo);
            return "".concat(user.last_name).concat(firstFormat, " ").concat(preferredFormat);
        });
    };
    /**
     * Returns `<first name> <middle name> <last name> (<preferred name>)` from BasicUserInfo
     * @param {BasicUserInfo} userInfo - the BasicUserInfo
     * @return {string} The formatted name
     */
    UserService.getFormattedName_FullLegalParenPreferred = function (userInfo) {
        return UserService.getFormattedName(userInfo, function (user) {
            var legalFormat = UserService.getFormattedLegalName_Full(userInfo);
            var preferredFormat = UserService.getFormattedName_ParenPreferred(userInfo);
            return "".concat(legalFormat, " ").concat(preferredFormat);
        });
    };
    /**
     * Wrapper to get the IRPs that a user is the lead for
     * @param {int} user_id
     * @return {Promise<string>} The IRPs a user is the lead of, separated by '/'
     */
    UserService.getIrpUserIsLeadFor = function (user_id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client
                        .query({
                        query: User_2.GetIrpsUserIsLeadFor,
                        variables: { user_id: user_id }
                    })
                        .then(function (_b) {
                        var data = _b.data;
                        return data.getIrpsUserIsLeadFor.join('/');
                    })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    }); };
    /**
     * Validates UserNameInfo
     * @param {BasicUserInfo} userInfo - the BasicUserInfo
     * @return {string|undefined} 'N/A' if invalid name object, else undefined
     */
    UserService.validateUserNameExists = function (user) {
        if (!user || (!user.first_name && !user.preferred_first_name && !user.last_name && !user.preferred_last_name)) {
            return 'N/A';
        }
        else {
            return undefined;
        }
    };
    /**
     * Base method for formatting UserNameInfo
     * @param {BasicUserInfo} userInfo - the BasicUserInfo
     * @param {function} formatter - the specific method
     * @return {string} The formatted name
     */
    UserService.getFormattedName = function (user, formatter) {
        var inValidName = UserService.validateUserNameExists(user);
        if (inValidName) {
            return inValidName;
        }
        else {
            return formatter(user);
        }
    };
    return UserService;
}());
exports["default"] = UserService;
